import React, { useState, useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { authSelector } from "./redux/selector";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";

// components
import SoftBox from "components/SoftBox";
import Illustration from "layouts/authentication/sign-in/illustration";

// example components
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";

// themes
import themeRTL from "assets/theme/theme-rtl";

// routes
// import routes from "routes";
import { mainRoute } from "routes";

// contexts
import { useSoftUIController, setMiniSidenav, setOpenConfigurator } from "context";

//css
import "./assets/style/custom.css";

// Images
import brand from "assets/images/logos/brain.png";
import ForgotPassword from "layouts/authentication/reset-password/illustration";
import AuthorityGuard from "route/authorityGuard";
import AccessDenied from "layouts/authentication/error/AccessDenied";

export default function App() {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, direction, layout, openConfigurator, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();
  const { user } = useSelector(authSelector);

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Change the openConfigurator state
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) => {
    return allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }
      if (route.route) {
        return (
          <Route
            key={route.key}
            path={route.route}
            element={
              <AuthorityGuard userAuthority={[user.role]} authority={route.authority}>
                {route.component}
              </AuthorityGuard>
            }
          />
        );
      }
      return null;
    });
  };

  const configsButton = (
    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="3.5rem"
      height="3.5rem"
      bgColor="white"
      shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="2rem"
      zIndex={99}
      color="dark"
      sx={{ cursor: "pointer" }}
      onClick={handleConfiguratorOpen}
    >
      <Icon fontSize="default" color="inherit">
        settings
      </Icon>
    </SoftBox>
  );

  return (
    <ThemeProvider theme={themeRTL}>
      <CssBaseline />
      {layout === "dashboard" && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={brand}
            brandName="Buchführung"
            routes={mainRoute}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
          <Configurator />
          {/* {configsButton} */}
        </>
      )}
      <Routes>
        {!user || Object.keys(user).length <= 0 ? (
          <>
            <Route exact path="/dashboards/sign-in" element={<Illustration />} key="sign-in" />
            <Route
              exact
              path="/dashboards/forgot-password"
              element={<ForgotPassword />}
              key="forgot-password"
            />
            <Route path="*" element={<Navigate to="/dashboards/sign-in" />} />
          </>
        ) : (
          <>
            {getRoutes(mainRoute)}
            <Route exact path="/access-denied" element={<AccessDenied />} />
            <Route path="*" element={<Navigate to="/research/accounting-account" />} />
          </>
        )}
      </Routes>
      <Toaster position="top-center" reverseOrder={false} />
    </ThemeProvider>
  );
}
